// Canonical route of the "Discover" navigation item (sidebar + offcanvas).
export const DISCOVER_ROUTE = '/discovery/countries';
